import styled from "styled-components";

/* The "connect a Keepo" modal's list: the PLUS Keepos to pick from (the frame, header and actions are the Modal's) */
export const KeepoList = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .keepo {
    display: flex;
    gap: 0.875rem;
    align-items: center;
    width: 100%;
    padding: 0.75rem 1rem 0.75rem 0.75rem;
    text-align: left;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid var(--color-neutral-base);
    border-radius: 0.875rem;
    transition:
      border-color 0.15s,
      background-color 0.15s;

    &:hover:not(:disabled) {
      border-color: var(--color-neutral-light);
    }

    &.selected {
      background: rgba(255, 255, 255, 0.04);
      border-color: var(--color-brand-plus);
      box-shadow: inset 0 0 0 1px var(--color-brand-plus);
    }
  }

  .avatar {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-size: 1rem;
    font-weight: 800;
    color: var(--color-neutral-white);
    background: var(--color-brand-blue);
    border-radius: 10px;
  }

  .text {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;

    b,
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    b {
      font-size: 0.9375rem;
      font-weight: 700;
      color: var(--color-neutral-white);
    }

    span {
      font-size: 0.75rem;
      color: var(--color-neutral-150);
    }
  }

  /* The one connected now */
  .current {
    flex-shrink: 0;
    padding: 0.125rem 0.5rem;
    font-size: 0.6875rem;
    font-weight: 700;
    color: var(--color-neutral-150);
    background: var(--color-neutral-base);
    border-radius: 100px;
  }

  .radio {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border: 2px solid var(--color-neutral-light);
    border-radius: 100%;
  }

  .selected .radio {
    border: 5px solid var(--color-brand-plus);
  }

  .empty {
    padding: 1.5rem 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
    text-align: center;
    background: rgba(255, 255, 255, 0.02);
    border-radius: 0.875rem;
  }
`;

export * from "./detail";
